// Meta Pixel helper — safely wraps window.fbq for event tracking across the app.

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
  }
}

export const META_PIXEL_ID = '2945020945847469'

/**
 * Track a standard or custom Meta Pixel event.
 * No-ops safely if the pixel hasn't loaded yet (e.g. blocked by an ad blocker).
 */
export function trackPixel(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  if (params) {
    window.fbq('track', event, params)
  } else {
    window.fbq('track', event)
  }
}
